import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { Button, ButtonTypes, PopupFooter, SearchInput } from '@gem/ui-kit';

import { ChipsWithAvatar } from 'APP/components/ChipsWithAvatar/ChipsWithAvatar';

import { MoveGroupsToSpaceList } from './MoveGroupsToSpaceList/MoveGroupsToSpaceList';
import {
  IMoveGroupsToSpacePopupParams,
  useMoveGroupsToSpacePresenter,
} from './MoveGroupsToSpacePopup.presenter';
import styles from './MoveGroupsToSpacePopup.styles.m.css';

export const MoveGroupsToSpacePopup: FC<ICommonPopupsProps<IMoveGroupsToSpacePopupParams>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useMoveGroupsToSpacePresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        title={t('space_addition_list')}
        isOpened={!!presenter.space}
        onClose={presenter.onClose}
      >
        <SearchInput
          className={styles.search}
          placeholder={t('main_menu_search_note')}
          value={presenter.searchText}
          onChange={presenter.onSearchChange}
        />

        <ChipsWithAvatar
          chips={presenter.chips}
          onRemove={presenter.onRemoveChips}
        />

        {presenter.space && (
          <MoveGroupsToSpaceList
            space={presenter.space}
            groups={presenter.groups}
            selectedGroups={presenter.checkedGroups}
            hasSearch={!!presenter.searchText}
            onToggleGroup={presenter.onToggleGroup}
          />
        )}

        <PopupFooter>
          <Button
            type={ButtonTypes.Button}
            isDisabled={presenter.isSubmitting || !presenter.checkedGroups.size}
            isLoading={presenter.isSubmitting}
            onClick={presenter.onSubmit}
            theme="primary"
          >
            {t('add_button')}
          </Button>
        </PopupFooter>
      </Popup>
    );
  });
